module.exports = __webpack_public_path__ + "img/data-center02.d6a8c06e.png";